import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';

import { useUiStore } from '@/stores';
import { UserService } from '@/services';
import { toastServiceError } from '@/services/core/notification';
import { UserModel, Permission, UserDeviceType, UserDeviceModel } from '@/types';

import { DesktopComputerIcon, DeviceMobileIcon } from '@heroicons/vue/solid';
import { InformationCircleIcon } from '@heroicons/vue/solid';
import SVGDeviceExternal from '@/components/svg/SVGDeviceExternal.vue';
import SVGChromeLogo from '@/components/svg/SVGChromeLogo.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'UserDetailPage',
  setup(__props, { expose: __expose }) {
  __expose();

const route = useRoute();
const uiStore = useUiStore();
const { t } = useI18n();

const user = ref<UserModel | null>(null);
const isLoading = ref(false);

const setLoading = (loading: boolean) => {
    isLoading.value = loading;
    uiStore.setIsLoading(loading);
};

const fetchUsers = async (id: number) => {
    setLoading(true);
    try {
        const response = await UserService.get<UserModel>(id);
        user.value = response.data;
    } catch (error) {
        toastServiceError(error);
    } finally {
        setLoading(false);
    }
};

const deviceCards = [
    {
        type: UserDeviceType.MOBILE,
        icon: DeviceMobileIcon,
    },
    {
        type: UserDeviceType.DESKTOP,
        icon: DesktopComputerIcon,
    },
    {
        type: UserDeviceType.WEB,
        icon: SVGChromeLogo,
    },
    {
        type: UserDeviceType.EXTERNAL,
        icon: SVGDeviceExternal,
    },
];

const devicesByType = computed<Record<UserDeviceType, UserDeviceModel | undefined>>(() => {
    const map = {} as Record<UserDeviceType, UserDeviceModel | undefined>;
    for (const d of user.value?.devices ?? []) map[d.deviceType] = d;
    return map;
});

const hasDevice = (type: UserDeviceType) => Boolean(devicesByType.value[type]);
const externalDevice = computed(() => devicesByType.value[UserDeviceType.EXTERNAL]);

const autoAttendantTooltip = computed(() => {
    return `<span class='text-base'>${t('user.tooltips.useAutoAttendant')}</span>`;
});

onMounted(() => {
    fetchUsers(Number(route.params.id));
});

const __returned__ = { route, uiStore, t, user, isLoading, setLoading, fetchUsers, deviceCards, devicesByType, hasDevice, externalDevice, autoAttendantTooltip, get Permission() { return Permission }, get UserDeviceType() { return UserDeviceType }, get InformationCircleIcon() { return InformationCircleIcon } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})